.reviewsSlider {
}

.title {
  color: #231e19;
  text-align: center;
  font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.4px;
  // margin-bottom: 24px;
}

.slider {
  padding-top: 24px;
  padding-bottom: 40px;
}

.glide__slides {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
}

.glide__slide {
  border-radius: 32px;
  background: #f3eddf;
  padding: 24px 24px 20px 24px;
  border-radius: 32px;
}

.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.headerImg {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.headerTitle {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  h3 {
    color: #231e19;
    text-align: center;
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.045px;
  }

  img {
    width: 120px;
  }
}

.itemtitle {
  color: #231e19;
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.045px;
  margin-bottom: 4px;
}

.itemReview {
  color: #231e19;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.045px;
}

// Dark mode
:global body.dark {
  :local {
    .title {
      color: #fffbf2;
    }

    .glide__slide {
      background: #2a2928;
    }

    .headerTitle h3, .itemtitle, .itemReview {
      color: #FFFBF2;
    }
  }
}
